define('lib/vp.excerpt2',['jquery'], function($){

/*!
 * Collapsable thingie
 * author: Darek Rossman
 */

(function () {

    var pluginName = 'collapsable',
        defaults = {
          wrapperClass: 'js-collapsable__wrap',
          toggleClass: 'js-collapsable__toggle',
          expandedClass: 'js-collapsable--expanded',
          expanded: false,
          maxLines: 5,
          lineHeight: 24
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);
        this.options = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }



    Plugin.prototype.init = function () {
      var self = this;      

      // get data-attribute options
      var dataOpts = this.$element.data();
      var toggleDtmLabel = (typeof dataOpts.toggleDtmLabel !== 'undefined') ? dataOpts.toggleDtmLabel : 'collapsable-toggle';

      this.options.maxLines = typeof dataOpts.maxLines !== 'undefined' ? dataOpts.maxLines : this.options.maxLines;
      this.options.lineHeight = dataOpts.lineHeight || this.options.lineHeight;

      this.options.startHeight = this.$element.height();
      this.options.collapseHeight = parseInt(this.options.maxLines) * this.options.lineHeight;

      if (this.options.startHeight > this.options.collapseHeight) {
        this.$element.wrapInner('<div class="'+ this.options.wrapperClass +'"/>');
        
        this.$toggle = $('<div class="js-collapsable__toggle icon-right-open" data-dtm="'+ toggleDtmLabel +'"/>');
        this.$wrap = this.$element.find('.' + this.options.wrapperClass);
        this.$element.append( this.$toggle );
        
        this.$toggle.on('click', function(){
          if (!self.options.expanded) {
            self.expand();
          } else {
            self.collapse();
          }
        });

        this.collapse();
      }
      this.$element.css('opacity', 1);
    };

    Plugin.prototype.expand = function() {
      this.$wrap
        .css('height', this.options.startHeight + 'px')
        .addClass( this.options.expandedClass );
      this.$toggle.text('Less');
      this.options.expanded = true;

      // this.$toggle.attr('data-dtm', '');
    };

    Plugin.prototype.collapse = function() {
      this.$wrap
        .css('height', this.options.collapseHeight + 'px')
        .removeClass( this.options.expandedClass );
      this.$toggle.text('More');
      this.options.expanded = false;

      // this.$toggle.attr('data-dtm', 'collapsable-toggle');
    }; 


    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                new Plugin( this, options ));
            }
        });
    }

})();









});

